import { Button } from 'antd';
import type { FC } from 'react';

import './Preview.scss';

export const Preview: FC<Props> = ({ onClick }) => (
  <div className="preview-btn">
    <Button size="large" onClick={onClick}>
      Preview
    </Button>
  </div>
);

type Props = {
  onClick?: () => void;
};
